import React from "react"

// Adding a link saves it straight away: the dashboard API creates the knowledge
// item and the scraper fills it in. So by the time its details show there's
// nothing left to save, and this says so and gives a way back to the list.
const moderationNote = moderationStatus => {
    if (moderationStatus === true) {
        return "It's approved."
    }
    if (moderationStatus === false) {
        return "It's rejected."
    }
    return "It still needs moderating: approve or reject it on the right."
}

const AddFeedSavedNotice = ({ moderationStatus, onDone }) => (
    <div className="widget-content active" id="add-feed-saved">
        <div className="alert alert-success" role="status">
            <p>
                <strong>✓ Saved to the knowledge base.</strong>
            </p>
            <p>
                {moderationNote(moderationStatus)} To change its details, edit
                them and click Save.
            </p>
            <button
                type="button"
                className="btn btn-primary"
                onClick={onDone}
                data-cy="addFeedDoneButton"
            >
                Back to knowledge
            </button>
        </div>
    </div>
)

export default AddFeedSavedNotice
